import React from 'react';
import { useAppSelector} from "../DAL/store";
import Imgix from "react-imgix";
import {
    clickProfileReportAnIssue, clickProfileSite,
    getEpochFromDate,
    getSocialIconByDomainName
} from '../../common/services/logic-provider';
import VerifiedIcon from "../../../../ui/svg/common/verified";
import { AVATAR_PATH } from '../../common/constants';


const CreatorDetailsMobile = () => {

    const PublicCreatorProfileData = useAppSelector((store) => store.PublicCreatorProfileData);
    const imgCdnDomain = useAppSelector((store) => store.imgCdnDomain);
    const creatorsPath = useAppSelector((store) => store.creatorsPath);

    return (
        <div className="w-full">
            <div className="flex items-center mt-8">
                <div className="min-w-40 w-40 mr-8" style={{minWidth:"120px"}}>
                    {PublicCreatorProfileData.profile.imgExt.length > 0 ?
                        <Imgix
                            src= {imgCdnDomain + "/" +
                                  creatorsPath +
                                  PublicCreatorProfileData.profile.prfUserGUID + "."  +
                                  PublicCreatorProfileData.profile.imgExt + "?epoch=" + getEpochFromDate(PublicCreatorProfileData.profile.itemModifiedWhen)
                            }
                            sizes={"auto"}
                            width={400}
                            height={400}
                            imgixParams={{ mask:"ellipse" }}
                            htmlAttributes={{
                                alt: `${PublicCreatorProfileData.profile.handle} profile image`,
                                loading: 'lazy',
                            }}
                        />
                        :
                        <Imgix
                            src= {imgCdnDomain + AVATAR_PATH}
                            sizes={"auto"}
                            width={400}
                            height={400}
                            imgixParams={{ fit: "facearea",facepad:"1.9",mask:"ellipse" }}
                            htmlAttributes={{
                                alt: `${PublicCreatorProfileData.profile.handle} profile image`,
                                loading: 'lazy',
                            }}
                        />
                    }
                </div>


            </div>
            <div className="overflow-hidden mt-4">
                <div className="w-full h-full">
                    <div className="w-full text-2xl font-bold flex justify-between items-center">
                        <div className="flex items-center justify-start">
                            <h1 className="max-w-fit">{PublicCreatorProfileData.profile.publicName}</h1>
                            {PublicCreatorProfileData.profile.isVerified &&
                                <div className="ml-2">
                                    <VerifiedIcon width="20px" />
                                </div>
                            }
                        </div>
                        <span className="text-base font-normal min-w-fit pl-2">
                            <div className="text-black underline cursor-pointer" onClick={() => clickProfileReportAnIssue(PublicCreatorProfileData.profile)}>Report an issue</div>
                        </span>

                    </div>
                    <div className="w-full py-4">
                        @{PublicCreatorProfileData.profile.handle}
                        {PublicCreatorProfileData.profile.isUserOwner ?
                            <span>
                                <span className="px-4">|</span>
                                <a href={"/account/edit-my-creator-profile"}>Edit Profile</a>
                            </span>
                            :<></>}
                    </div>
                </div>
            </div>

            <div className="w-full mt-2">
                {PublicCreatorProfileData.profile.bio}
            </div>
            <div className="w-full flex items-center justify-center mt-6">
                {PublicCreatorProfileData.sites.length > 0 &&
                    <div className="font-bold text-lg pr-6">Follow</div>
                }

                <div className="flex-1 grid grid-cols-5">
                    {PublicCreatorProfileData.sites.map((site,index) => {
                        return  <div key={index} className={`w-auto grid-item cursor-pointer `} onClick={() => clickProfileSite(site)} >{getSocialIconByDomainName(site.domainName,"20px")}</div>
                    })}
                </div>

            </div>

        </div>

    )
};

export default CreatorDetailsMobile;